import { useState } from "react";
import { motion } from "framer-motion";
import { MapPin, Star, ArrowUpRight } from "lucide-react";

const placeholderImg = "/Assets/Img/chef_default.png";

export default function ChefCard({ chef }) {
  const [hovered, setHovered] = useState(false);

  const specialties =
    chef?.specialty?.length > 0 ? chef.specialty : ["Not Available"];

  const chefName = chef?.sellerProfile?.user?.name || "Chef Name";
  const avatar = chef?.sellerProfile?.user?.avatar || placeholderImg;
  const origin = chef?.name || "Unknown Origin";

  return (
    <a
      href={`/SellerProfile/${chef?._id}`}
      style={{ textDecoration: "none", display: "block" }}
    >
      <motion.div
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        transition={{ duration: 0.3, ease: "easeOut" }}
        style={{
          width: "100%",
          fontFamily: "'Inter', sans-serif",
          cursor: "pointer",
        }}
      >
        {/* Image container */}
        <div
          style={{
            position: "relative",
            borderRadius: 14,
            overflow: "hidden",
            marginBottom: 10,
          }}
        >
          <motion.img
            src={avatar}
            alt={chefName}
            animate={{ scale: hovered ? 1.04 : 1 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
            style={{
              width: "100%",
              height: 220,
              objectFit: "cover",
              objectPosition: "center top",
              display: "block",
            }}
          />
          {/* Bottom gradient overlay */}
          <div
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              height: 70,
              background:
                "linear-gradient(to top, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.4) 30%, rgba(0,0,0,0.15) 60%, rgba(0,0,0,0.03) 85%, transparent 100%)",
              pointerEvents: "none",
            }}
          />
          {/* Origin on image */}
          <div
            style={{
              position: "absolute",
              bottom: 10,
              left: 10,
              display: "flex",
              alignItems: "center",
              gap: 4,
              fontSize: 11,
              fontWeight: 600,
              color: "#fff",
            }}
          >
            <MapPin size={11} />
            {origin}
          </div>
          {/* Arrow button */}
          <motion.div
            animate={{
              opacity: hovered ? 1 : 0,
              scale: hovered ? 1 : 0.8,
            }}
            transition={{ duration: 0.2 }}
            style={{
              position: "absolute",
              top: 10,
              right: 10,
              width: 28,
              height: 28,
              borderRadius: "50%",
              backgroundColor: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <ArrowUpRight size={14} color="#111" strokeWidth={2.5} />
          </motion.div>
        </div>

        {/* Info below image */}
        <div style={{ padding: "0 2px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: 4,
            }}
          >
            <h3
              style={{
                margin: 0,
                fontSize: 14,
                fontWeight: 700,
                color: "#111827",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                flex: 1,
              }}
            >
              {chefName}
            </h3>
            {chef?.reviews?.count > 0 && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 3,
                  fontSize: 12,
                  fontWeight: 600,
                  color: "#111827",
                  marginLeft: 8,
                }}
              >
                <Star size={11} fill="#111827" color="#111827" strokeWidth={0} />
                {chef.reviews.rating}
              </div>
            )}
          </div>

          <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
            {specialties.slice(0, 2).map((s, i) => (
              <span
                key={i}
                style={{
                  fontSize: 11,
                  color: "#6b7280",
                  fontWeight: 500,
                }}
              >
                {s}
                {i < Math.min(specialties.length, 2) - 1 ? " · " : ""}
              </span>
            ))}
          </div>
        </div>
      </motion.div>
    </a>
  );
}
